import React from 'react'

import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import ServiceOrdersPublicListItem from './ServiceOrdersListItem'

const ServiceOrdersPublicHistory = () => {
  const serviceOrders = useServiceOrders()

  return serviceOrders.map(item => <ServiceOrdersPublicListItem key={item.id} item={item} />)
}

export default ServiceOrdersPublicHistory
